export default {
  title: 'Importação de faturas. Resultado da importação',
  table: {
    file: 'Arquivo',
    provider: 'Fornecedor',
    client: 'Cliente',
    number: 'Nº da Fatura',
    ammount: 'Valor',
    result: 'Resultado',
    comment: 'Comentário'
  },
  correct: 'Faturas corretas',
  incorrect: 'Faturas rejeitadas',
  notTreated: 'Faturas não tratadas',
  total: 'Total de faturas',
  error: 'A importação falhou. Verifique as faturas incorretas. Nenhuma fatura foi registrada. Para continuar, pressione Aceitar.',
  partialError: 'A importação falhou. Verifique a fatura incorreta. {0} fatura não foi registrada. Para continuar, pressione Aceitar. | A importação falhou. Verifique as faturas incorretas. {0} faturas não foram registradas. Para continuar, pressione Aceitar.',
  success: 'A importação foi concluída. {0} fatura foi importada. Para continuar, pressione Aceitar. | A importação foi concluída. {0} faturas foram importadas. Para continuar, pressione Aceitar.'
}